import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { ToastProvider } from '../components/Toast';
import { SessionProvider } from '../features/auth/session';
import { ApiError } from '../lib/errors';

const NO_RETRY = new Set(['not_found', 'forbidden', 'not_verified', 'account_banned', 'not_authenticated']);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (count, error) => !(error instanceof ApiError && NO_RETRY.has(error.code)) && count < 2,
    },
  },
});

export function Providers({ children }: { children: ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <ToastProvider>{children}</ToastProvider>
      </SessionProvider>
    </QueryClientProvider>
  );
}
